module.exports = __webpack_public_path__ + "media/images/samples/infographics/zoomed-639af5be7dad4becf5583859f49b6c5b.jpg";